import * as React from 'react'
import { Icon, IconButton } from '@material-ui/core'
import styled from 'styled-components'
import Router from 'next/router'

const StyledHeader = styled.header({
  margin: '0px 10px 10px 10px',
  height: 50,
  display: 'flex',
  alignItems: 'center',
})

const Header = ({
  back = false,
  onBack = null,
  style = {},
  children = null,
}) => {
  return (
    <StyledHeader style={style}>
      {(back || onBack) && (
        <IconButton size="small" onClick={onBack || (() => Router.back())}>
          <Icon>arrow_back</Icon>
        </IconButton>
      )}
      {children}
    </StyledHeader>
  )
}

export default Header
